import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { createApiClient } from './lib/api';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('Élément #root introuvable');

const api = createApiClient({ baseUrl: import.meta.env.VITE_API_BASE_URL ?? '' });

createRoot(root).render(
  <StrictMode>
    <App api={api} />
  </StrictMode>,
);
